import React from 'react';

import {
  //IndexView,
  Home1 as HomeView1,
  Legal as LegalView,
  Filers as FilersView,
  Reports as ReportsView,
  Data as DataView,
  Search as SearchView,
  Publications as PublicationsView,  
  Municipal as MunicipalView, 
  About as AboutView,
  NotFound as NotFoundView,
} from '../views';

import legalRoutes from './Legal/routes';
import filerRoutes from './Filers/routes';
import reportsRoutes from './Reports/routes';
import publicationRoutes from './Publications/routes';
import dataRoutes from './Data/routes';
import municipalRoutes from './Municipal/routes';
import aboutRoutes from './About/routes';
import searchRoutes from './Search/routes';

const routes = [
  {
    path: '/not-found',
    renderer: (params = {}): JSX.Element => <NotFoundView {...params} />,
  },
  {
    path: '/',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/index',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/home',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/home1',
    renderer: (params = {}): JSX.Element => <HomeView1 {...params} />,
  },
  {
    path: '/Legal',
    renderer: (params = {}): JSX.Element => <LegalView {...params} />,
  },
  {
    path: '/Filers',
    renderer: (params = {}): JSX.Element => <FilersView {...params} />,
  },
  {
    path: '/r', //link from OCPFORG in X
    renderer: (params = {}): JSX.Element => <FilersView {...params} />,
  },
  {
    path: '/Reports',
    renderer: (params = {}): JSX.Element => <ReportsView {...params} />,
  },
  {
    path: '/Reports/Index',
    renderer: (params = {}): JSX.Element => <ReportsView {...params} />,
  },
  {
    path: '/Publications',
    renderer: (params = {}): JSX.Element => <PublicationsView {...params} />,
  },
  {
    path: '/Data',
    renderer: (params = {}): JSX.Element => <DataView {...params} />,
  },
  {
    path: '/Elections/MonthlyCharts', //previous link  to monthly charts
    renderer: (params = {}): JSX.Element => <DataView {...params} />,
  },
  {
    path: '/municipal',
    renderer: (params = {}): JSX.Element => <MunicipalView {...params} />,
  },
  {
    path: '/Search',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/PublicSearch',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/PublicSearch/Index',
    renderer: (params = {}): JSX.Element => <SearchView {...params} />,
  },
  {
    path: '/About',
    renderer: (params = {}): JSX.Element => <AboutView {...params} />,
  },
  ...legalRoutes,
  ...filerRoutes,
  ...reportsRoutes,
  ...publicationRoutes,
  ...dataRoutes,
  ...municipalRoutes,
  ...aboutRoutes,
  ...searchRoutes
];

export default routes;
